export interface WalletPixKeys {
  timestamp: string;
  status: string;
  data: PixKeyData[];
  error?: ErrorResponse;
  errors?: ErrorResponse[];
  page: number;
  metadata?: Record<string, any>;
  translations?: Record<string, string>;
  total_pages: number;
  per_page: number;
  total_items: number;
}

export interface PixKeyData {
  id: number;
  value: string;
  pixKeyType: PixKeyType;
  principal: boolean;
  hash: string;
  active: boolean;
}

export type PixKeyType =
  | 'RANDOM'
  | 'CPF'
  | 'EMAIL'
  | 'PHONE'
  | 'CNPJ'
  | 'SOCIAL_SECURITY';

export interface ErrorResponse {
  error: string;
  title: string;
  code: string;
  trace: string;
  metadata?: Record<string, any>;
  description: string;
  modal: boolean;
}

export function createEmptyWalletPixKeysData(): PixKeyData[] {
  return [];
}
